import React, { createContext, useState, useEffect } from 'react';
import api from '../api';

// Crée le contexte d'authentification
export const AuthContext = createContext();

// Composant fournisseur pour AuthContext
export const AuthProvider = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [hasLtd, setHasLtd] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {

            console.log("Token : " + localStorage.getItem('token'));

            setIsAuthenticated(true);

            api.get('/user_info')
            .then(response => {
                setUser(response.data);
            })
            .catch(error => console.error(error));

            api.get('/get_subscription')
            .then(response => {
                setSubscription(response.data);
            })
            .catch(error => console.error(error));

            api.get('/has_ltd')
            .then(response => {
                setHasLtd(response.data.has_ltd);
            })
            .catch(error => console.error(error))
            .finally(() => setIsLoading(false));
        } else {
            setIsLoading(false);
        }

    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, user, setUser, subscription, setSubscription, hasLtd, setHasLtd, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};
